import React from 'react';
import { formatDate, parseDate } from 'react-day-picker-v7/moment';
import { compose, withHandlers, withPropsOnChange, withState, withProps, lifecycle } from 'recompose';

import config from '../../../../config';
import OverlayInput from '../components/OverlayInput';

const enhance = compose(
  withProps(() => ({
    inputRef: React.createRef(),
  })),
  withState('inputValue', 'setInputValue', props => formatDate(props.value, config.dateFormat)),
  withState('isValid', 'setIsValid', true),
  withPropsOnChange(
    ['value'],
    (props) => {
      props.setInputValue(formatDate(props.value, config.dateFormat));
      props.setIsValid(true);
    },
  ),
  withHandlers({
    updateValue: props => () => {
      const parsed = parseDate(props.inputValue, config.dateFormat);
      if (parsed) {
        props.onChange(parsed);
      }

      const isValid = !!parsed;
      props.setIsValid(isValid);

      return isValid;
    },
  }),
  withHandlers({
    onBlur: props => props.updateValue,
    onChange: props => (event) => {
      props.setInputValue(event.target.value);
    },
    onKeyDown: props => (event) => {
      const keyCode = event.keyCode ? event.keyCode : event.charCode;
      if (keyCode === config.ENTER_KEY_CODE) {
        const isValid = props.updateValue();
        if (isValid) {
          props.onEnterPressed();
        }
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.autoFocus && this.props.inputRef && this.props.inputRef.current) {
        // setting autoFocus to the input directly makes DatePicker blink on opening.
        // adding transition-delay to css only helps about half the times,
        // and so does using setImmediate here
        this.focusTimeoutId = setTimeout(() => {
          this.props.inputRef.current.focus();
          this.focusTimeoutId = null;
        }, 200);
      }
    },
    componentWillUnmount() {
      if (this.focusTimeoutId) {
        clearTimeout(this.focusTimeoutId);
      }
    },
  })
);

export default enhance(OverlayInput);
